import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({ name: 'headerName' })
export class HeaderNamePipe implements PipeTransform {
  transform(value: Array<any>, ...args: any[]): string {
    let timezone;
    if (args[3]) {
      if (args[3].length !== 3 && args[3].length !== 4) {
        timezone = moment.tz(args[3]).format('z');
      } else {
        timezone = args[3];
      }
    }
    let name = args[0] + ' | ' + args[1] + ' | ' + args[2] + ' | (' + timezone + ')';

    return name;
  }
}
